import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function TourGuestTable() {
  const { t } = useTranslation();
  const name: any = 'approvalable.tourSales.0.tourSaleGuests';
  const value = HOCWatchValue({ keys: [name] });
  const data = value[name];

  const columns = [
    {
      header: t('common:guest'),
      accessorKey: 'guestName',
      minSize: 100,
      dataType: ColumnDataType.text,
    },

    {
      header: t('common:preferences'),
      accessorKey: 'guestPreferences',
      minSize: 250,
      dataType: ColumnDataType.tags,
      tagKeyName: 'label',
      maxTags: 2,
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={data}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
